module.exports = __webpack_public_path__ + "img/22.cad4e4bb.svg";